module.exports = __webpack_public_path__ + "static/media/ss-logo-secondary.da0234e0.png";